module.exports = __webpack_public_path__ + "static/media/tanan-assistant-qr.ff39ddaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tanan-assistant-qr.png
// module id = 71
// module chunks = 0